const company = {
  duplicate: 5000,
  not_found: 5001,
};

export default company;
